import { Machine } from './machine';
import { StateName } from './stateName';
export class TypeState {

	/*1*/ 	public id: number;
	/*2*/ 	public typeStateName: string;
	/*3*/ 	public colorState: string;
	/*4*/ 	public colorGroup?: number;
	/*5*/ 	public stateName?: StateName;
	/*6*/ 	public commandID?: number;
	/*7*/ 	public stateNames?: StateName;
	/*8*/ 	public machines?: Machine[];
	/*9*/ public order: number
	/*10*/ public typestateacronim: string;
	/*11*/ public view: boolean = true;
	/*12*/ public primaryLocation?: string;
	/*12b*/ public primaryLocationName?: string;
	/*13*/ public definition?: string;
	/*14*/ public ramCategory?: string;
	/*15*/ public ramCategoryName?: string;
	/*16*/ public downtimeType?: string;
	/*17*/ public isFailureEvent?: boolean;
	/*18*/ public maintenanceLevel?: string;

	public totalmachines?: number;
	constructor(s?: any) {
		this.id = s ? s.id : null;
		this.typeStateName = s ? s.typeStateName : null;
		this.colorState = s ? s.colorState : null;
		this.colorGroup = s ? s.colorGroup : null;
		this.stateName = s ? s.stateName : null;
		this.commandID = s ? s.commandID : null;
		this.order = s ? s.order : null;
		this.typestateacronim = s ? s.typestateacronim : null;
		this.primaryLocation = s ? s.primary_location || s.primaryLocation : null;
		this.primaryLocationName = s ? s.primary_location_name || s.primaryLocationName : null;
		this.definition = s ? s.definition : null;
		this.ramCategory = s ? s.ram_category || s.ramCategory : null;
		this.ramCategoryName = s ? s.ram_category_name || s.ramCategoryName : null;
		this.downtimeType = s ? s.downtime_type || s.downtimeType : null;
		this.isFailureEvent = s ? (s.is_failure_event ?? s.isFailureEvent ?? false) : false;
		this.maintenanceLevel = s ? s.maintenance_level || s.maintenanceLevel : null;
	}

}
